module.exports = __webpack_public_path__ + "02_long_gray.1b5e8311.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/02_long_gray.png
// module id = RRjc
// module chunks = 0